import { Link } from 'react-router-dom';
import { StyledDivider, StyledHeader, StyledLabel } from './app-header.style';

export const AppHeader = () => {
    return (
        <StyledHeader>
            <StyledDivider>
                <Link
                    to="https://libmogilev.by/touristfood/%d0%b3%d0%b0%d1%81%d1%82%d1%80%d0%be%d1%84%d0%b5%d1%81%d1%82%d1%8b-%d0%b0%d0%b3%d1%80%d0%be%d1%83%d1%81%d0%b0%d0%b4%d1%8c%d0%b1%d1%8b/"
                    target='_blank'
                >
                    <StyledLabel>Гастрономический туризм</StyledLabel>
                </Link></StyledDivider>
        </StyledHeader>
    )
}